import formatter from "@/services/formatter";

export default {
    methods: {
        formatPrice (amount) {
            return formatter.Price.format(amount)
        },

    },
    computed:{
        calculatePrice() {
            return function(numberOfSide= 1, numberOfShirt) {

                let shirt = 1300
                let printing = 1000
                let base_fee = 2200

                //base_fee include 1500 for procurement
                //300 for packaging
                //400 profit
                return  (numberOfShirt * shirt) + base_fee + (numberOfSide * printing)
            }
        }
    }
}
